import * as React from "react";
import groq from "groq";
import Layout from "../components/Layout";
import client from "../../client";
import RenderSections from "../components/render-sections";
import {
	extractPropertyInfo,
	GenericPageProps,
	getSiteSettings,
	pageQuery,
} from "../routes/common";
import { normalizeHeroImage } from "../routes/images";
import type { Page } from "../types/generated/schema";
import type { GetStaticPaths, GetStaticProps, NextPage } from "next";
import type { ParsedUrlQuery } from "querystring";

const LandingPageIndex: NextPage<GenericPageProps> = ({ pageData, config }) => {
	return (
		<Layout config={config} tags={pageData.seo}>
			{pageData.content && <RenderSections sections={pageData.content} />}
		</Layout>
	);
};

export default LandingPageIndex;

export const getStaticProps: GetStaticProps<GenericPageProps> = async ({
	params,
}) => {
	const sanityPageData = await client
		.fetch<Page>(pageQuery, { slug: params.slug })
		.then((res) => ({ ...res }));

	const config = await getSiteSettings();

	if (!sanityPageData.content || !config) {
		return {
			notFound: true,
		};
	}

	const data = normalizeHeroImage(sanityPageData);
	const pageData = await extractPropertyInfo(data);

	return {
		props: {
			pageData,
			config,
		},
		revalidate: 60,
	};
};

export const getStaticPaths: GetStaticPaths = async () => {
	const paths = await client.fetch<string[]>(
		groq`*[_type == "page" && defined(slug.current)][].slug.current`,
	);

	return {
		paths: generateLandingPages(paths),
		fallback: "blocking",
	};
};

type LandingPagePaths = (
	| string
	| {
			params: ParsedUrlQuery;
			locale?: string;
	  }
)[];

function generateLandingPages(paths: string[]): LandingPagePaths {
	return paths.flatMap((slug) => {
		if (slug === "/") return [];
		if (slug === "aanbod") return [];

		return { params: { slug } };
	});
}
